
  import { fixPrice } from '@/utils/general'
  import { Component } from 'vue-property-decorator'
  import Cell from './cell'

@Component({
  methods: {
    fixPrice,
  },
})
  export default class PaymentOrderPricesCell extends Cell {
  declare item: any // PaymentOrder type
  payments: any[] = []

  async mounted () {
    if (this.item?.paymentItems?.length) {
      this.payments = this.item.paymentItems
    }
  }

  get displayedPayments () {
    return this.payments.slice(0, 3)
  }

  get hasMorePayments () {
    return this.payments.length > 3
  }

  get remainingCount () {
    return this.payments.length - 3
  }
  }
